export const ICON_CONFIG = {
  iconCooper: 'assets/icons/icon-cooper.svg',
  iconEurope: 'assets/icons/icon-europe.svg',
  iconRouteShort: 'assets/icons/icon-route-short.svg',
  iconFreightPlanned: 'assets/icons/icon-freight-planned.svg',
} as const;

// derivative type for safe typing
export type AppIcon = keyof typeof ICON_CONFIG;
